{
  "bodyInputLabel": "Cuerpo",
  "bodyInputPlaceholder": "Describa su problema:",
  "callUs": "Llámanos",
  "cancel": "Cancelar",
  "chooseYourProduct": "Elige tu producto",
  "contactUs": "Contáctenos",
  "continue": "Continuar",
  "createSupportTicketDescription": "Cree un ticket de soporte en nuestro sistema para obtener asistencia directa de uno de nuestros empleados.",
  "createSupportTicketHelpContentWithPhoneNumber": "Nuestro equipo revisa y atiende periódicamente los tickets de soporte. Si prefieres hablar con alguien, puedes llamarnos al {{phoneNumber}}.",
  "createSupportTicketTitle": "Crear un ticket de soporte",
  "emailUs": "Envíenos un correo electrónico",
  "exitAppPromptMessage": "Está a punto de navegar a app.farmhq.com para acceder a la documentación de soporte.",
  "exitAppPromptTitle": "¿Continuar a FarmHQ Web?",
  "farmHqIsHereToHelp": "FarmHQ está aquí para ayudarte. Comunícate con nosotros si tienes algún problema y nos comunicaremos contigo lo antes posible.",
  "getHelpWithFarmHq": "Obtenga ayuda con FarmHQ",
  "sendUsAMessage": "Envíanos un mensaje",
  "shareFeedback": "Compartir comentarios",
  "shareFeedbackDescription": "Cuéntenos cómo funciona nuestro producto para usted y cómo podemos hacerlo funcionar aún mejor.",
  "subjectInputLabel": "Sujeto",
  "subjectInputPlaceholder": "Necesito ayuda con...",
  "support": "Apoyo",
  "supportCenter": "Centro de soporte",
  "supportDocumentationLink": "Ver documentación de soporte",
  "title": "Centro de soporte",
  "topic_one": "Tema",
  "topic_other": "Temas",
  "viewInstructionManual": "Ver manual de instrucciones",
  "viewSupportDocsDescription": "Lea la documentación sobre instalación, resolución de problemas, uso de la aplicación y otros temas en app.farmhq.com.",
  "weHaveReceivedYourMessage": "¡Hemos recibido tu mensaje!"
}
